export default __webpack_public_path__ + "static/media/desktop-single-image.54bc55bc.jpg";